module.exports = __webpack_public_path__ + "static/img/store-icon6.5d6d019.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/store-icon6.png
// module id = hCje
// module chunks = 1